<template>

  <div ref="mainHigh" class="mianLogin">
    <div ref="dash" class="dash" @click="closeDash()">
    </div>
    <!-- 提高通过率tip -->
    <div ref="airBg" class="airBg">
      <div class="closeBtn" @click="closeDash()">
        <CloseOutlined/>
      </div>
      <div class="contAir">
        <h2>高企申报Tips！</h2>

        <!--                <h3>请关注公众号</h3>
                        <h3>高企申报不迷路</h3>2024年高企申报开始了！
                        第一批申报截止时间为6月20日；
                        第二批申报截止时间为8月12日；
                        第三批申报截止时间为9月25日-->
                       <h4>2025年高新技术企业认定分四批受理，以企业完成网上申报操作、完整申请材料报送到受理部门的时间为准：</h4>
                        <h4>第一批受理截止时间：2025年5月26日；</h4>
                        <h4>第二批受理截止时间：2025年6月24日；</h4>
                        <h4>第三批受理截止时间：2025年8月11日；</h4>
                        <h4>第四批受理截止时间：2025年9月11日。</h4>
        <h4 style="margin:.5rem 0">咨询电话：2292730</h4>
        <h4>长按二维码联系专属申报助力官,</h4>
        <h4>助你通向高企之路</h4>
        <div class="wm">
          <p><img src="../img/ywhn.png" alt=""><br/>
            <span>助力官：宇文浩男</span>
          </p>
          <p><img src="../img/wtj.png" alt=""><br/>
            <span>助力官：王天骄</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 查看结果 -->
    <div ref="airBg1" class="airBg" style="background: #fff;">
      <div class="closeBtn" @click="closeDash1()">
        <CloseOutlined/>
      </div>
      <div class="contAir" style="display:block;margin-top:1rem;height:80vh">
        <div class="questions" v-for="(item,key) in formList" :key="key">
          <h5> {{ key + 1 }} 、 {{ item.questions }}</h5>
          <p style="color:#a8a8a8">{{ item.explainInfo }}</p>
          <p>答案：{{ item.answerContent }}</p>
          <a-divider/>
        </div>
      </div>
    </div>

    <div ref="airBg2" class="airBg imgAir" style="background: #fff;">
      <div class="closeBtn" @click="closeDash1()">
        <CloseOutlined/>
      </div>
      <img style="width: 120%;margin-left:-2.5rem" :src="home_url" alt="">
      <div style="position:relative;z-index:9999;text-align: center;bottom:3rem" @click="closeDash1()">
        <button style="padding:.5rem 2rem">关闭</button>
      </div>
    </div>
    <div class="backTop">
      <LeftOutlined class="fl" @click="goBack()"/>
    </div>
    <div class="topScope" v-if="form">
      测评结果：
      <p>
        <span v-if="isAccord">{{ form.scoreEvaluation }}</span>
        <span v-else>恭喜您！{{ form.scoreEvaluation }}</span>
        <a v-if="isAccord" style="color: #00cc00;text-decoration:underline; " @click="dashOpen()"><br/>~如需提升，请找高企一对一助力官~</a>
      </p>
      <h1>{{ formatNumber(score()||form.totalScore) }}</h1>
      <p>综合得分</p>
      <div class="itemScope">
        <ul>
          <li>
            <span><i>{{ formatNumber(form['财务成长性']) }}</i>/20</span>
            <p>财务成长性</p>
          </li>
          <li>
            <span><i>{{ formatNumber(form['知识产权和成果转化']) }}</i>/60</span>
            <p>知识产权和<br>成果转化</p>
          </li>
          <li>
            <span><i>{{ formatNumber(form['研发组织管理水平']) }}</i>/20</span>
            <p>研发组织<br>管理水平</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="input-groud" v-if="form">
      <span style="font-size:.8rem">相关建议</span>
      <p><i v-if="form.proposal">({{ form.proposal }})</i><span
        v-if="form.deputyProposal.includes('满足')">{{ form.deputyProposal }}</span>
        <span v-else><span
          style="font-size: 25px;font-weight: bold;color: #0d1c28">{{ firstFourChars }}</span>{{ lastFourChars }}</span>
      </p>
      <!-- <p><i>高企认定条件：近一年高企技术产品（服务）收入占企业同期总收入的比例不低于60%</i></p> -->
      <a-button class="subtn" size="large" type="primary" @click="dashOpen()">点击提高通过率</a-button>
    </div>
    <p class="download">
      <a-button class="subtn" size="large" @click="dashOpen1()">查看结果</a-button>
      <a-button class="subtn" size="large" type="primary" @click="getMoban()">下载微测评报告</a-button>
    </p>
  </div>
</template>

<script>
import {basicsEvaluateResult, basicsEvaluateRecords} from "@/api/webHighEnterpriseEvaluation";
import {ls} from "@/utils/util";
import axios from "axios";

export default {

  data() {
    return {
      logoState: false,
      form: null,
      formList: null,
      isAccord: null,
      home_url: null,
    }
  },
  mounted() {
    this.$refs.mainHigh.style.height = window.innerHeight + 'px'
    this.submitEvaluate()
    this.RecordsList()
  },
  computed: {

    firstFourChars() {
      return this.form.deputyProposal.substring(0, 4);
    }, lastFourChars() {
      return this.form.deputyProposal.substring(4);
    }
  },
  methods: {
    score(){
      return this.$route.query.score
    },
    formatNumber(number) {
      let intNumber = parseFloat(number);
      if (intNumber.toFixed(1).endsWith('0')) {
        return intNumber.toFixed(0);
      }
      return intNumber.toFixed(1);
    },
    // 下载
    exportExcelTemplate() {
      axios({
        methods: 'get',
        url: basicsEvaluateResult.exportEvaluate,
        params: {
          user: ls.get('wxLoginPhone'),
          evaluateFlag: this.$route.query.flag
        },
        responseType: 'blob',
      }).then(data => {
        const blob = new Blob([data.data], {type: "application/pdf"});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a"); // 创建a标签
        link.href = url;
        link.download = decodeURIComponent('微测评报告.pdf');// 文件重命名，若无需重命名，将该行删去
        link.click();
        URL.revokeObjectURL(url); // 释放内存
      })
    },
    // 预览
    getMoban() {
      setTimeout(() => {
        this.$refs.airBg2.style.display = 'block'
      }, 1000);
      axios({
        methods: "get",
        url: basicsEvaluateResult.exportEvaluate,
        params: {
          user: ls.get('wxLoginPhone'),
          evaluateFlag: this.$route.query.flag
        },
        responseType: 'arraybuffer',
        // headers: {
        // 'content-type': 'application/x-www-form-urlencoded',
        // Authorization: 'Bearer' + ls.get('token') || ''
        // }
      }).then(res => {
        let bytes = new Uint8Array(res.data);
        let data = "";
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          data += String.fromCharCode(bytes[i]);
        }
        this.home_url = "data:image/png;base64," + window.btoa(data);

      })
    },
    goBack() {
      this.$router.go(-1)
    },
    // 结果详情
    RecordsList() {
      this.getAction({
          url: basicsEvaluateRecords.list,
          params: {
            user: ls.get('wxLoginPhone'),
            evaluateFlag: this.$route.query.flag
          }
        }
      ).then((res) => {
        if (res) {
          this.formList = res
        }
      })
    },
    // 结果详情
    submitEvaluate() {
      this.postAction({
          url: basicsEvaluateResult.getEvaluateResult,
          params: {
            user: ls.get('wxLoginPhone'),
            evaluateFlag: this.$route.query.flag
          }
        }
      ).then((res) => {
        if (res) {
          this.form = res
          if (res.isAccord == 'false') {
            this.isAccord = false
          } else {
            this.isAccord = true
          }
        }
      })
    },
    dashOpen() {
      this.$refs.dash.style.display = 'block'
      this.$refs.airBg.style.display = 'flex'
    },

    closeDash() {
      this.$refs.dash.style.display = 'none'
      this.$refs.airBg.style.display = 'none'
      this.$refs.airBg1.style.display = 'none'
      this.$refs.airBg2.style.display = 'none'
    },
    dashOpen1() {
      this.$refs.dash.style.display = 'block'
      this.$refs.airBg1.style.display = 'flex'
    },
    closeDash1() {
      this.$refs.dash.style.display = 'none'
      this.$refs.airBg1.style.display = 'none'
      this.$refs.airBg2.style.display = 'none'
    },
    //路由跳转
    goMore(url, str) {
      if (str) {
        this.$router.push({path: url, query: {id: str}})
      } else {
        this.$router.push(url)
      }
    },
  }
};
</script>
<style lang="less" scoped>
.mianLogin {
  position: relative;
  font-family: '微软雅黑';
  width: 100%;
  background: url(../img/bg.jpg) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .dash {
    position: fixed;
    z-index: 9;
    display: none;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
  }

  .airBg {
    position: fixed;
    top: 50%;
    left: 50%;
    display: none;
    align-items: center;
    justify-content: center;
    /* 将div的左上角移动到页面中央 */
    transform: translate(-50%, -50%);
    z-index: 99;
    width: 92vw;
    height: 90vh;
    background: url(../img/bg2.jpg) no-repeat;
    background-size: 100% 100%;
    border-radius: .5rem;

    .closeBtn {
      position: absolute;
      right: 0;
      top: 0;
      color: #222;
      border: .1rem solid #f1f1f1;
      background: #f1f1f1;
      font-weight: bold;
      padding: .1rem .3rem;
      border-radius: 1rem;
    }

    .contAir {
      height: 90vh;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      overflow: auto;
      font-family: '宋体';
      text-shadow: 0px 0px 2px #fff;

      .wm {
        margin-top: 1rem;
        display: flex;

        p {
          text-align: center;

          img {
            width: 75%;
          }

          span {
            font-weight: bold;
            color: #fff
          }
        }
      }

      .questions {
        font-size: .9rem;
        color: #50dcff;
      }

      h5 {
        font-size: .9rem;
      }

      h2 {
        text-align: center;
        color: #fff;
        font-weight: bold;
        padding-bottom: 1rem;
      }

      h3 {
        text-align: center;
        color: #fff;
        font-weight: bold;
        padding-bottom: 1rem;
      }

      h4 {
        text-align: center;
        color: #fff;
        font-size: .9rem;
        font-weight: bold;
        line-height: 1.8rem;
      }

      padding: 0 1rem;
    }
  }

  .imgAir {
    height: 100vh;
    width: 100vw;
    overflow: auto;
    overflow-x: hidden
  }

  .backTop {
    width: 100%;
    text-align: center;
    height: 2rem;
    padding-top: .2rem;
    font-size: 1.1rem;

    .fl {
      float: left;
      margin: .3rem 0 0 1rem;
    }
  }

  .topScope {
    width: 85%;
    margin-top: 2rem;
    font-size: .8rem;

    h1 {
      font-size: 3.5rem;
      color: #1c4ff7;
      line-height: 4rem;
      margin-top: 1rem;
      margin-bottom: .5rem;
    }

    p {
      font-weight: bold;
      line-height: 1.2rem;
      font-size: .8rem;
    }

    .itemScope {
      margin: 2rem 0;
      font-size: 1rem;

      ul {
        li {
          i {
            font-style: normal;
            font-size: 1.4rem;
            color: #1c4ff7
          }

          p {
            font-size: .8rem;
          }

          float: left;
          width: 31%;
          margin-right: .5rem;

          &:nth-child(3) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .input-groud {
    margin: 1rem 0;
    display: flex;
    flex-direction: column;
    width: 85vw;
    padding: .5rem 1rem;
    background: #fff;
    position: relative;
    border-radius: .4rem;
    font-size: .7rem;

    span {
      padding: 0 .2rem;
      color: #1c4ff7;
    }

    p {
      color: #555555;
      margin-top: .2rem;
      margin-bottom: .5rem;
      line-height: 1.4rem;

      i {
        font-style: normal;
        color: red;
      }
    }

  }

  .download {
    margin-top: 2rem;
    display: flex;
    width: 90%;
    padding: 0 .6rem;

    .subtn {
      margin-top: 0;
      flex: 3;
      font-size: 1rem;
      padding-bottom: 1rem;

      &:nth-child(1) {
        flex: 2;
        margin-right: 1rem;
        background: #fff;
        color: #1c4ff7;
        border: .1rem solid #1c4ff7;
      }

    }
  }

  .subtn {
    flex: 1;
    margin-top: .5rem;
    border-radius: .5rem;
    padding: .3rem 0 .5rem;
    font-size: 1.1rem;
    text-align: center;
    background: #1c4ff7;
  }
}
</style>
